






































































































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import AlertArea from "../../components/AlertArea.vue";
import { PracticeSheetListCondition, RowSpanInfo } from "../../modules/teacher/PracticeSheetList"

export interface Data {
  condition: PracticeSheetListCondition
  sheets: any[]
  totalCount: number
  sheetRowSpanInfos: RowSpanInfo[]
  errors: string[]
  isShow: boolean
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(prop, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      condition: new PracticeSheetListCondition(),
      sheets: [],
      totalCount: 0,
      sheetRowSpanInfos: new Array<RowSpanInfo>(),
      errors: new Array<string>(),
      isShow: false
    });

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");

      await http.get(`/api/teacher/practice_sheet_list?${Common.BuildQuery(state.condition, 'search_sheet')}`).then(response => {
        const sheets = response.data.sheets;

        const sheetRowSpanInfos = new Array<RowSpanInfo>();
        for(let i = 0; i < sheets.length; i++){
          const sheet = sheets[i];
          if(sheetRowSpanInfos.length == 0 || sheetRowSpanInfos[sheetRowSpanInfos.length - 1].sheet_group_key != sheet.sheet_group_key){
            sheetRowSpanInfos.push(new RowSpanInfo(sheet.id, sheet.sheet_group_key, 1));
          }else{
            sheetRowSpanInfos[sheetRowSpanInfos.length - 1].count++;
          }
        }
        state.sheetRowSpanInfos = sheetRowSpanInfos;

        if(sheets.length > 0){
          state.totalCount = sheets[0].at_full_count;
        }
        
        state.sheets = sheets;

        context.root.$store.commit("setPracticeSheetListCondition", state.condition);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 検索ボタン押下
     ******************************/

    const searchClick = () => {
      state.condition.page = 1;
      search();
    }

    /******************************
     * クリアボタン押下
     ******************************/
    
    const clearCondition = () => {
      state.condition = new PracticeSheetListCondition();
    };

    /******************************
     * 一覧テーブル rowspan設定
     * 同一sheet_group_keyの先頭レコードの場合
     * rowspanを設定する
     ******************************/
    
    const rowSpan = (sheet: any) => {
      var rowInfo = state.sheetRowSpanInfos.filter(x => x.sheet_id == sheet.id);
      return rowInfo.length > 0 ? rowInfo[0].count : 1;
    };

    /******************************
     * 一覧テーブル tdの表示制御
     * rowspan未設定行を非表示にする
     ******************************/
    
    const tdStyle = (sheet: any) => {
      const rowInfo = state.sheetRowSpanInfos.filter(x => x.sheet_id == sheet.id);
      return rowInfo.length > 0 ? {} : {"display": "none"};
    };

    /******************************
     * 全体平均点計算
     ******************************/
    const calcAllAverage = (sheet: any) => {
      const sheets = state.sheets.filter((x: any) => x.sheet_group_key == sheet.sheet_group_key);
      const score = Common.sumArray(sheets.map((x: any) => Number(x.at_sum_score)));
      const attendCount = Common.sumArray(sheets.map((x: any) => x.at_attend_count));
      
      return Number(Math.round(score * 10 / attendCount)) / 10;
    };

    /******************************
     * 一覧テーブル trのスタイル
     ******************************/
    
    const trStyle = (sheet: any) => {
      var rowInfo = state.sheetRowSpanInfos.filter(x => x.sheet_group_key == sheet.sheet_group_key);
      if(rowInfo.length > 0){
        var rowIdx = state.sheetRowSpanInfos.indexOf(rowInfo[0]);
        return rowIdx % 2 == 1 ? {"background-color": "#f2f2f2"} : {};
      }
    };

    /******************************
     * 実施日列の表示用に日付文字列をコンバート
     ******************************/

    const convertExecDate = (execDate: string) => {
      return execDate ? moment(execDate).format('M月D日') : "-";
    };

    /******************************
     * 採点設定完了状態
     ******************************/

    const isSettingCompleted = (sheet: any) => {
      if(sheet.is_recog_position_edit_enable){
        return sheet.recog_positions_completed;
      }else{
        return sheet.score_positions_completed;
      }
    }

    /******************************
     * 一覧のページ変更
     ******************************/
    
    const changePage = (page: number) => {
      state.condition.page = page;
      search();
    };

    /******************************
     * 採点設定アイコン押下
     ******************************/
    
    const saitenSettingClick = (sheet: any) => {

      context.root.$store.commit("setIsRecogPositionEditEnable", sheet.is_recog_position_edit_enable);

      // 採点設定の進捗により遷移先を制御
      if(sheet.score_positions_completed){
        if(sheet.is_recog_position_edit_enable){
          context.root.$router.push(`/teacher_site/recog_position_edit/${sheet.sheet_group_key}`).catch(err => {});
        }else{
          context.root.$router.push(`/teacher_site/score_position_edit/${sheet.sheet_group_key}`).catch(err => {});
        }
      }else if(sheet.corretct_image_completed){
        context.root.$router.push(`/teacher_site/position_edit/${sheet.sheet_group_key}`).catch(err => {});
      }else if(sheet.part1_names_completed){
        context.root.$router.push(`/teacher_site/correct_image_upload/${sheet.sheet_group_key}`).catch(err => {});
      }else if(sheet.field_names_completed){
        context.root.$router.push(`/teacher_site/practice_part1_edit/${sheet.sheet_group_key}`).catch(err => {});
      }else{
        context.root.$router.push(`/teacher_site/practice_field_edit/${sheet.sheet_group_key}`).catch(err => {});
      }
    };
    
    /******************************
     * 画面リロード
     ******************************/

    const reload = () => {
      location.reload();
    };

    /******************************
     * mounted キャッシュしている検索条件で検索実行
     ******************************/
    
    onMounted(async () => {
      state.condition = context.root.$store.state.practiceExamSheetListCondition as PracticeSheetListCondition;
      await search();
      context.root.$store.commit("setIsFilterMisaiten", null);
      context.root.$store.commit("setIsHeaderDisp", true);
      context.root.$store.commit("setSheetType", Common.SheetTypeEnum.Practice);
      state.isShow = true;
    });

    return {
      ...toRefs(state),
      search,
      searchClick,
      clearCondition,
      rowSpan,
      tdStyle,
      trStyle,
      convertExecDate,
      isSettingCompleted,
      changePage,
      saitenSettingClick,
      reload,
      calcAllAverage,
    }
  }
});

